app.EnterpriseTagList = app.AbstractCollection.extend({
  model: app.EnterpriseTag,

  url() {
    return '/api/v2/enterprise-tags';
  },
});
